import {
  FALLBACK_ERROR_MESSAGE,
  INVALID_INPUT_MESSAGE,
  INVALID_RECAPTCHA_MESSAGE,
  SUPPORT_CONTACT_LINK,
  SUPPORT_EMAIL_MAIL_TO,
} from "@/constants"

export const errors = {
  INVALID_COMBINATION: {
    title: "Email or password incorrect",
    message: "Your email address and/or password were not recognised, please check and try again.",
    links: [
      { label: "Forgot password", href: "/legacy/forgot-password" },
      { label: "Sign in with SANS", href: "/sign-in" },
    ],
  },
  FAILED_TO_FETCH: {
    title: "We were unable to submit your request",
    message: "Please try again, or contact us if the problem persists.",
    links: [SUPPORT_CONTACT_LINK],
  },
  CAPTCHA_FAILED: {
    title: `reCAPTCHA failed`,
    message: `We were unable to validate your request. Please refresh your browser and try again`,
    links: [{ label: `Contact us`, href: SUPPORT_EMAIL_MAIL_TO }],
  },
  ACCOUNT_NOT_VERIFIED: {
    title: "Account not verified",
    message: "The account associated with this email has not yet been verified.",
    links: [
      {
        label: "Still haven't received an email? Contact us",
        href: SUPPORT_EMAIL_MAIL_TO,
      },
    ],
  },
  INVALID_RECAPTCHA: INVALID_RECAPTCHA_MESSAGE,
  INVALID_INPUT: INVALID_INPUT_MESSAGE,
  FALLBACK_ERROR: FALLBACK_ERROR_MESSAGE,
}
